import { Network, ConnectionStatus } from '@capacitor/network'
import { computed, ComputedRef, ref } from 'vue'

type UseNetworkReturn = {
  /**Returns true if connected */
  getStatus: ComputedRef<ConnectionStatus['connected']>
}

const currentStatus = ref()
const boot = async () => {
  currentStatus.value = (await Network.getStatus()).connected
}
export const useNetwork = (): UseNetworkReturn => {
  void boot()
  void Network.addListener('networkStatusChange', (status) => {
    console.log('Network status changed', status)
    currentStatus.value = status.connected
  }).catch((error) => console.log(error))

  const getStatus = computed(() => {
    return currentStatus.value
  })
  return {
    getStatus,
  }
}
